import React from 'react';

import { QuoteCardWithScoreImprovements } from '@marketing/components/testimonial_card';

import AnitaHeadshot from './assets/anita_headshot.png';
import SophieHeadshot from './assets/sophie_headshot.png';

export default (props) => {
  return (
    <div className="d-flex flex-column flex-lg-row gap-m">
      <QuoteCardWithScoreImprovements
        examSections={[
          { name: 'Verbal', score: 164, scoreIncrease: 10 },
          { name: 'Math', score: 165, scoreIncrease: 5 },
          { name: 'Total', score: 329, scoreIncrease: 15 }
        ]}
        studentAvatar={AnitaHeadshot}
        studentName="Anita"
      >
        As a working professional with very little time to prep, Magoosh was the perfect platform. The videos were short and crisp and the practice questions were effective and motivating.
      </QuoteCardWithScoreImprovements>

      <QuoteCardWithScoreImprovements
        examSections={[
          { name: 'Verbal', score: 166, scoreIncrease: 4 },
          { name: 'Math', score: 170, scoreIncrease: 12 },
          { name: 'Total', score: 336, scoreIncrease: 18 }
        ]}
        studentAvatar={SophieHeadshot}
        studentName="Sophie"
      >
        It gave me a good checklist of things to do every day that I could go through. That was nice because I didn't have to think about what I was planning on doing, so I could just focus on studying.
      </QuoteCardWithScoreImprovements>
    </div>
  );
};
